var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters } from 'vuex';
import { CART } from '@/stores/defs';
// @ts-ignore
import ContentModal from '@ContentModal';
// @ts-ignore
import Tips from '@/components/checkout/Tips.vue';
var tipsMixin = {
    computed: __assign({}, mapGetters({
        getTotals: CART.GET_TOTALS,
    })),
    methods: {
        getTotalPrice: function () {
            var total = this.getTotals.subTotal;
            var tax = this.getTotals.tax;
            return tax + total;
        },
        showTipsModal: function (onClose) {
            var isMobile = (this.$mq === 'mobile');
            var modalWidth = (isMobile) ? '100%' : '740px';
            var modalHeight = (isMobile) ? '280px' : '370px';
            var showHeader = (isMobile) ? false : true;
            this.$modal.show(ContentModal, {
                contentComponent: Tips,
                contentProperties: {
                    price: this.getTotalPrice(),
                },
                header: {
                    title: '',
                    showBackButton: false,
                    showHeader: showHeader,
                },
                footer: {
                    showFooter: false,
                },
                mainContentUseAutoHeight: true,
            }, {
                name: 'contentModal',
                width: modalWidth,
                height: modalHeight,
                scrollable: true,
                clickToClose: false,
            }, {
                'closed': function (event) {
                    onClose();
                }
            });
        },
    },
};
export default tipsMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/tipsMixin.ts
// module id = 1FcU
// module chunks = 18